import { Link } from 'react-router-dom'
import { Instagram, Twitter, Linkedin, Mail } from 'lucide-react'
import './Footer.css'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <img src="/assets/logo/logo.png" alt="Digital vCard" className="logo-image" style={{ height: '40px' }} />
              <span>Digital vCard</span>
            </Link>
            <p className="footer-tagline">
              Your smart digital visiting card. Create, share, and grow your professional network.
            </p>
            <div className="footer-social">
              <a href="#" aria-label="Instagram"><Instagram size={20} /></a>
              <a href="#" aria-label="Twitter"><Twitter size={20} /></a>
              <a href="#" aria-label="LinkedIn"><Linkedin size={20} /></a>
              <a href="#" aria-label="Email"><Mail size={20} /></a>
            </div>
            
            <div className="footer-producthunt">
              <a
                href="https://www.producthunt.com/products/digital-vcard?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-digital-vcard"
                target="_blank"
                rel="noreferrer"
              >
                <img 
                  src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1048583&theme=light&t=1765362075393" 
                  alt="Digital vCard - Your smart digital visiting card | Product Hunt" 
                  className="footer-producthunt-badge"
                  width="250" 
                  height="54" 
                />
              </a>
            </div>
          </div>

          {/* Links */}
          <div className="footer-links">
            <h4>Product</h4>
            <ul>
              <li><a href="#features">Features</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><Link to="/signup">Get Started</Link></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Company</h4>
            <ul>
              <li><a href="#">About Us</a></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><a href="#">Blog</a></li>
            </ul>
          </div>

          <div className="footer-links">
            <h4>Legal</h4>
            <ul>
              <li><Link to="/privacy">Privacy Policy</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/refund">Refund Policy</Link></li>
              <li><Link to="/shipping">Shipping Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Digital vCard. All rights reserved.</p>
          <p>Made with ❤️ in India</p>
        </div>
      </div>
    </footer>
  )
}
